import React, { useState } from 'react';
import { Title, Text, Paper, TextInput, Textarea, Button, Group, Select, Stack, Badge, Divider, FileInput, NumberInput } from '@mantine/core';
import { ArrowLeft, Save, Send, Clock, Users, FileText, Image as ImageIcon, Calendar } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function CreateCampaignPage() {
  const navigate = useNavigate();
  const [campaignName, setCampaignName] = useState('');
  const [selectedList, setSelectedList] = useState<string | null>(null);
  const [message, setMessage] = useState('');
  const [startDate, setStartDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [interval, setInterval] = useState<number | string>(30);
  const [file, setFile] = useState<File | null>(null);
  const lists = [{
    value: '1',
    label: 'Deputados (45 contatos)'
  }, {
    value: '2',
    label: 'Vereadores (78 contatos)'
  }, {
    value: '3',
    label: 'Suplentes (32 contatos)'
  }, {
    value: '4',
    label: 'Coordenadores (25 contatos)'
  }, {
    value: '5',
    label: 'Diretório Municipal (150 contatos)'
  }];
  const variables = [{
    label: '{nome}',
    description: 'Nome do contato'
  }, {
    label: '{cargo}',
    description: 'Cargo político'
  }, {
    label: '{municipio}',
    description: 'Município'
  }, {
    label: '{partido}',
    description: 'Partido'
  }];
  const insertVariable = (variable: string) => {
    setMessage(message + ' ' + variable);
  };
  const getContactCount = () => {
    if (!selectedList) return 0;
    const list = lists.find(l => l.value === selectedList);
    if (!list) return 0;
    const match = list.label.match(/\((\d+) contatos\)/);
    return match ? parseInt(match[1]) : 0;
  };
  const calculateEstimatedTime = () => {
    const contactCount = getContactCount();
    const intervalSeconds = typeof interval === 'number' ? interval : parseInt(interval) || 30;
    const totalSeconds = contactCount * intervalSeconds;
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor(totalSeconds % 3600 / 60);
    if (hours > 0) {
      return `${hours}h ${minutes}min`;
    }
    return `${minutes}min`;
  };
  const getPreviewMessage = () => {
    return message.replace('{nome}', 'João Silva').replace('{cargo}', 'Deputado Estadual').replace('{municipio}', 'São Paulo').replace('{partido}', 'PSDB');
  };
  return <div className="space-y-6" data-id="element-287">
      <Button leftSection={<ArrowLeft size={18} data-id="element-289" />} onClick={() => navigate('/campaigns')} radius="lg" styles={{
      root: {
        backgroundColor: 'transparent',
        border: '1px solid #9ca3af',
        color: '#4b5563',
        height: '40px',
        '&:hover': {
          backgroundColor: '#f3f4f6'
        }
      }
    }} data-id="element-288">
        Voltar para Campanhas
      </Button>
      <div className="flex justify-between items-center" data-id="element-290">
        <div data-id="element-291">
          <Title order={2} className="text-primary" data-id="element-292">
            Nova Campanha
          </Title>
          <Text c="dimmed" data-id="element-293">Crie uma nova campanha de mensagens</Text>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-294">
        <div className="lg:col-span-2 space-y-6" data-id="element-295">
          <Paper radius="lg" p="md" withBorder data-id="element-296">
            <Title order={4} mb="md" data-id="element-297">
              Informações da Campanha
            </Title>
            <Stack gap="md" data-id="element-298">
              <TextInput label="Nome da Campanha" placeholder="Ex: Convocação Assembleia Maio 2024" required value={campaignName} onChange={e => setCampaignName(e.currentTarget.value)} leftSection={<FileText size={18} data-id="element-300" />} data-id="element-299" />
              <Select label="Lista de Destinatários" placeholder="Selecione uma lista" data={lists} required value={selectedList} onChange={setSelectedList} leftSection={<Users size={18} data-id="element-302" />} data-id="element-301" />
              {selectedList && <Badge color="blue" variant="light" size="lg" data-id="element-303">
                  {getContactCount()} contatos selecionados
                </Badge>}
            </Stack>
          </Paper>
          <Paper radius="lg" p="md" withBorder data-id="element-304">
            <Title order={4} mb="md" data-id="element-305">
              Mensagem
            </Title>
            <Stack gap="md" data-id="element-306">
              <div data-id="element-307">
                <Text size="sm" fw={500} mb="xs" data-id="element-308">
                  Variáveis Disponíveis
                </Text>
                <Group gap="xs" data-id="element-309">
                  {variables.map(variable => <Button key={variable.label} size="xs" variant="light" onClick={() => insertVariable(variable.label)} data-id="element-310">
                      {variable.label}
                    </Button>)}
                </Group>
                <Text size="xs" c="dimmed" mt="xs" data-id="element-311">
                  Clique para inserir variáveis na mensagem
                </Text>
              </div>
              <Textarea label="Texto da Mensagem" placeholder="Digite a mensagem que será enviada..." required minRows={6} value={message} onChange={e => setMessage(e.currentTarget.value)} data-id="element-312" />
              <FileInput label="Anexar Mídia (Opcional)" placeholder="Selecione uma imagem, documento ou áudio" accept="image/*,application/pdf,audio/*" value={file} onChange={setFile} leftSection={<ImageIcon size={18} data-id="element-314" />} data-id="element-313" />
            </Stack>
          </Paper>
          <Paper radius="lg" p="md" withBorder data-id="element-315">
            <Title order={4} mb="md" data-id="element-316">
              Agendamento e Intervalo
            </Title>
            <Stack gap="md" data-id="element-317">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-318">
                <TextInput label="Data de Início" type="date" required value={startDate} onChange={e => setStartDate(e.currentTarget.value)} leftSection={<Calendar size={18} data-id="element-320" />} data-id="element-319" />
                <TextInput label="Horário de Início" type="time" required value={startTime} onChange={e => setStartTime(e.currentTarget.value)} leftSection={<Clock size={18} data-id="element-322" />} data-id="element-321" />
              </div>
              <NumberInput label="Intervalo entre Mensagens" description="Tempo de espera entre cada envio para evitar bloqueios" placeholder="30" required min={10} max={300} value={interval} onChange={setInterval} suffix=" segundos" leftSection={<Clock size={18} data-id="element-324" />} data-id="element-323" />
              {selectedList && <div className="bg-blue-50 p-4 rounded-lg" data-id="element-325">
                  <Group justify="space-between" data-id="element-326">
                    <div data-id="element-327">
                      <Text size="sm" fw={500} data-id="element-328">
                        Tempo Estimado de Conclusão
                      </Text>
                      <Text size="xs" c="dimmed" data-id="element-329">
                        Baseado em {getContactCount()} contatos
                      </Text>
                    </div>
                    <Badge size="lg" color="blue" data-id="element-330">
                      {calculateEstimatedTime()}
                    </Badge>
                  </Group>
                </div>}
            </Stack>
          </Paper>
        </div>
        <div className="space-y-6" data-id="element-331">
          <Paper radius="lg" p="md" withBorder data-id="element-332">
            <Title order={4} mb="md" data-id="element-333">
              Preview da Mensagem
            </Title>
            <div className="bg-gray-50 p-4 rounded-lg" data-id="element-334">
              <Text size="sm" c="dimmed" mb="xs" data-id="element-335">
                Exemplo de como a mensagem aparecerá:
              </Text>
              <div className="bg-white p-3 rounded-lg border border-gray-200" data-id="element-336">
                <Text size="sm" style={{
                whiteSpace: 'pre-wrap'
              }} data-id="element-337">
                  {message ? getPreviewMessage() : 'Digite uma mensagem para ver o preview...'}
                </Text>
              </div>
              {file && <div className="mt-3" data-id="element-338">
                  <Badge color="green" variant="light" data-id="element-339">
                    Anexo: {file.name}
                  </Badge>
                </div>}
            </div>
          </Paper>
          <Paper radius="lg" p="md" withBorder data-id="element-340">
            <Title order={4} mb="md" data-id="element-341">
              Resumo
            </Title>
            <Stack gap="sm" data-id="element-342">
              <div data-id="element-343">
                <Text size="sm" c="dimmed" data-id="element-344">
                  Destinatários
                </Text>
                <Text size="sm" fw={500} data-id="element-345">
                  {getContactCount()} contatos
                </Text>
              </div>
              <Divider data-id="element-346" />
              <div data-id="element-347">
                <Text size="sm" c="dimmed" data-id="element-348">
                  Data de Início
                </Text>
                <Text size="sm" fw={500} data-id="element-349">
                  {startDate && startTime ? `${new Date(startDate).toLocaleDateString('pt-BR')} às ${startTime}` : 'Não definido'}
                </Text>
              </div>
              <Divider data-id="element-350" />
              <div data-id="element-351">
                <Text size="sm" c="dimmed" data-id="element-352">
                  Intervalo
                </Text>
                <Text size="sm" fw={500} data-id="element-353">
                  {interval} segundos
                </Text>
              </div>
              <Divider data-id="element-354" />
              <div data-id="element-355">
                <Text size="sm" c="dimmed" data-id="element-356">
                  Tempo Estimado
                </Text>
                <Text size="sm" fw={500} data-id="element-357">
                  {calculateEstimatedTime()}
                </Text>
              </div>
            </Stack>
          </Paper>
          <Stack gap="sm" data-id="element-358">
            <Button leftSection={<Send size={18} data-id="element-360" />} radius="lg" fullWidth styles={{
            root: {
              backgroundColor: '#0047AB',
              height: '48px',
              '&:hover': {
                backgroundColor: '#003d91'
              }
            }
          }} data-id="element-359">
              Agendar Campanha
            </Button>
            <Button leftSection={<Save size={18} data-id="element-362" />} radius="lg" fullWidth styles={{
            root: {
              backgroundColor: 'transparent',
              border: '1px solid #0047AB',
              color: '#0047AB',
              height: '48px',
              '&:hover': {
                backgroundColor: '#E3F2FD'
              }
            }
          }} data-id="element-361">
              Salvar Rascunho
            </Button>
          </Stack>
        </div>
      </div>
    </div>;
}